<script>
  import { f7, Block, AccordionContent } from 'framework7-svelte';

  export let name;
  export let name_show;
  export let author;
  export let tags = [];

</script>
